import { render } from "./ZZJG.vue?vue&type=template&id=0d4ce6d5"
import script from "./ZZJG.vue?vue&type=script&lang=js"
export * from "./ZZJG.vue?vue&type=script&lang=js"

import "./ZZJG.vue?vue&type=style&index=0&id=0d4ce6d5&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__